import { render, staticRenderFns } from "./RIDEditView.vue?vue&type=template&id=f2989c98&scoped=true"
import script from "./RIDEditView.vue?vue&type=script&lang=js"
export * from "./RIDEditView.vue?vue&type=script&lang=js"
import style0 from "./RIDEditView.vue?vue&type=style&index=0&id=f2989c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2989c98",
  null
  
)

export default component.exports